import React from 'react'
import { format } from 'date-fns';
import { Button, Stack, TableCell, TableRow } from "@mui/material";
import { useConfirm } from "material-ui-confirm";
import { fetchAPI } from "@/utility/NetworkUtils";

export default function ReportEntry({ report, event, onDeleted = () => {} }) {
  const confirm = useConfirm()

  const handleDelete = async () => {
    const { confirmed } = await confirm({
      description: `Are you sure you want to delete "${report.name}"? This cannot be undone.`,
      confirmationText: "Yes, Delete This.",
      cancellationText: "No"
    })
    if (!confirmed) return

    fetchAPI(`/events/${event.id}/reports/${report.id}`, (json) => {
      if (json && json.errors) {
        console.log({ errors: json.errors })
        return
      }
      onDeleted(report.id)
    }, { method: "DELETE" })
  }

  return (
    <TableRow>
      <TableCell sx={{ width: "100%" }}>{report.name}</TableCell>
      <TableCell sx={{ whiteSpace: "nowrap" }}>
        {report.created_at ? format(new Date(report.created_at), "MM/dd/yyyy, h:mm a") : ""}
      </TableCell>
      <TableCell align="right">
        <Stack direction="row" spacing={1} justifyContent="flex-end">
          {report.completed ? (
            <Button
              component="a"
              href={report.report_url}
              target="_blank"
              size="small"
            >
              View
            </Button>
          ) : (
            <Button size="small" disabled>Generating...</Button>
          )}
          {report.id && (
            <Button onClick={handleDelete} size="small" color="error">
              Delete
            </Button>
          )}
        </Stack>
      </TableCell>
    </TableRow>
  )
}
